import * as React from 'react';
import { DescItem, formatDate } from '@setel/portal-ui';
import { useUserTierProgress } from '../membership-queries';

const validityMap: any = {
  forever: 'Forever',
  end_of_next_month: 'End Of Next Month',
};

export function CustomDescList({ children }: { children: React.ReactNode }) {
  return (
    <div
      // since this app is dealing with 320px screen size. It makes more sense to have a consistence interface
      style={{ gridTemplateColumns: '130px 155px', display: 'inline-grid' }}
    >
      {children}
    </div>
  );
}

export function MembershipDetail({ userId }: { userId: string }) {
  const { data: userTierProgress, isLoading: isLoadingUserTierProgress } =
    useUserTierProgress(userId);

  return (
    <div className="px-4 pt-5 mb-5">
      <div className="text-xs uppercase font-bold mb-4 text-lightgrey">
        Membership
      </div>
      <CustomDescList>
        <DescItem
          label="Tier"
          value={userTierProgress && userTierProgress?.currentTier.title}
        />
        <DescItem
          valueClassName="mt-4"
          labelClassName="mt-4"
          label="Progress"
          value={
            !isLoadingUserTierProgress &&
            userTierProgress && (
              <>
                {/* following the logic in angular code */}
                {userTierProgress.currentTier.requirements.map(
                  (requirement, index) => (
                    <div key={'' + requirement.min}>
                      {`${userTierProgress.requirementsProgress[index].value} ${
                        requirement?.max ? 'of ' + requirement.max : ''
                      } ${requirement.unitLabel}`}
                    </div>
                  )
                )}
              </>
            )
          }
        />
        <DescItem
          valueClassName="mt-4"
          labelClassName="mt-4"
          label="Validity"
          value={
            (userTierProgress?.currentTier?.validity &&
              validityMap[userTierProgress?.currentTier?.validity]) ||
            '-'
          }
        />
        <DescItem
          valueClassName="mt-4"
          labelClassName="mt-4"
          label="Duration"
          value={
            userTierProgress &&
            `${formatDate(userTierProgress.appliedAt, {
              formatType: 'dateAndTime',
            })} - 
            ${
              userTierProgress.expiredAt
                ? formatDate(userTierProgress.expiredAt, {
                    formatType: 'dateAndTime',
                  })
                : 'N/A'
            }`
          }
        />
        <DescItem
          valueClassName="mt-4"
          labelClassName="mt-4"
          label="Requirement benefit"
          value={
            userTierProgress && (
              <ul>
                {userTierProgress?.currentTier.privileges.map((privilege) => (
                  <li
                    key={privilege.type + privilege.label}
                    className="mb-4 list-disc"
                  >
                    {privilege.label}
                  </li>
                ))}
              </ul>
            )
          }
        />
      </CustomDescList>
      <hr />
    </div>
  );
}
